import { AxiosError } from 'axios';
import { useState } from 'react';

import { DashboardOverview, DateRangeOption } from '../../../models/dashboard/overview.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDashboardOverview = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [overview, setOverview] = useState<DashboardOverview | null>(null);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Failed to load dashboard overview');
  };

  const onSuccess = ({ data }: SuccessHttpResponse<DashboardOverview>) => {
    setOverview(data);
  };

  const fetchOverview = (range: DateRangeOption, startDate?: string, endDate?: string) => {
    const url: HttpConfig = {
      url: 'api/v1/admin/dashboard/overview',
      method: 'get',
      params: {
        range,
        ...(range === 'custom' ? { start_date: startDate, end_date: endDate } : {}),
      },
    };

    request(url, onSuccess, setLoading, onError);
  };

  return { overview, loading, fetchOverview };
};

export default useDashboardOverview;
